import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选全网最热吃瓜专题，一键直达完整爆料内容
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {indexTopics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                <i className={`text-lg text-primary-500 ${topic.icon}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors duration-200">
                    {topic.title}
                  </span>
                  {topic.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      topic.tag === '爆' ? 'bg-primary-100 text-primary-600' :
                      topic.tag === '热' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {topic.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{topic.count} 篇内容</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}